import React from 'react';
import useOrganizationGroups from '../../../../../../hooks/api/useOrganizationGroups';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { mainContentPadding } from '../../../../../v2BaseComponents/MainContentContainer';
import GroupsTable from './GroupsTable';
import { View } from 'react-native';
import { useIsMobileLayout } from '../../../../../../hooks/useIsMobileLayout';

export type GroupsTabOwnProps = {};

export type GroupsTabProps = GroupsTabOwnProps;

const GroupsTab: React.FC<GroupsTabProps> = () => {
    const { isLoadingGroups } = useOrganizationGroups({});
    const isMobile = useIsMobileLayout();
    return (
        <AnimateLoadedContent isLoading={isLoadingGroups}>
            {() => (
                <View style={{ width: '100%', height: '100%', paddingTop: isMobile ? undefined : mainContentPadding }}>
                    <GroupsTable />
                </View>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(GroupsTab);
